export enum UserAccountModal {
  EMAIL_VERIFICATION = 'email_verification',
  RESET_PASSWORD_EMAIL = 'reset_password_email',
  PASSWORD_RESET_SUCCESSFULLY = 'password_reset_successfully',
  PASSWORD_CHANGED_SUCCESSFULLY = 'password_changed_successfully',
  EMAIL_VERIFICATION_CHECKOUT = 'email_verification_checkout',
  EMAIL_VERIFIED_SUCCESSFULLY = 'email_verified_successfully',
  DEFAULT = 'default_does_not_exist',
}
